<template>
    <div class="box-selector">
        <div class="box-selector-header">
            <h3>盒子选择</h3>
            <el-input
                v-model="searchText"
                placeholder="搜索盒子名称或编码"
                prefix-icon="Search"
                clearable
                @input="filterBoxes" />
        </div>

        <div class="box-selector-content">
            <el-scrollbar height="400px">
                <div
                    v-for="box in filteredBoxes"
                    :key="box.id"
                    class="box-item"
                    :class="{ active: selectedBox && selectedBox.id === box.id }"
                    @click="selectBox(box)">
                    <div class="box-info">
                        <div class="box-name">{{ box.name }}</div>
                        <div class="box-code">编码: {{ box.code }}</div>
                        <div class="box-type">类型: {{ box.type }}</div>
                    </div>
                    <div class="box-status">
                        <el-tag
                            :type="box.online_status === 1 ? 'success' : 'danger'"
                            size="small">
                            {{ box.online_status === 1 ? '在线' : '离线' }}
                        </el-tag>
                    </div>
                </div>

                <div v-if="filteredBoxes.length === 0" class="no-data">
                    <el-empty description="没有找到匹配的盒子" />
                </div>
            </el-scrollbar>
        </div>

        <div v-if="selectedBox" class="box-selector-footer">
            <div class="selected-box-info">
                <span>已选择: {{ selectedBox.name }} ({{ selectedBox.code }})</span>
            </div>
            <el-button type="primary" size="small" @click="confirmSelection">
                确认选择
            </el-button>
        </div>
    </div>
</template>

<script>
import {ref, computed, onMounted, getCurrentInstance} from 'vue';
import {notify} from '../../assets/js/utils.js';

export default {
    name: 'BoxSelector',
    emits: ['box-selected'],
    setup(props, {emit}) {
        const boxes = ref([]);
        const selectedBox = ref(null);
        const searchText = ref('');

        // 获取当前组件实例，用于访问 axios
        const {proxy} = getCurrentInstance();

        const filteredBoxes = computed(() => {
            if (!searchText.value) {
                return boxes.value;
            }

            const search = searchText.value.toLowerCase();
            return boxes.value.filter(box =>
                box.name.toLowerCase().includes(search)
            || box.code.toLowerCase().includes(search),
            );
        });

        const loadBoxes = async () => {
            try {
                const response = await proxy.axios.get('/api/boxes');
                boxes.value = response.data.data || [];
            } catch (error) {
                console.error('Failed to load boxes:', error);
                notify('error', '加载盒子列表失败');
            }
        };

        const filterBoxes = () => {
            // 过滤逻辑已在computed中处理
        };

        const selectBox = (box) => {
            selectedBox.value = box;
            // 立即发送选择事件，不需要等待确认按钮
            emit('box-selected', box);
            notify('success', `已选择盒子: ${box.name}`);
        };

        const confirmSelection = () => {
            // 保留确认按钮功能，但已经在selectBox中发送了事件
            if (selectedBox.value) {
                notify('success', `已确认选择盒子: ${selectedBox.value.name}`);
            }
        };

        onMounted(() => {
            loadBoxes();
        });

        return {
            boxes,
            selectedBox,
            searchText,
            filteredBoxes,
            filterBoxes,
            selectBox,
            confirmSelection,
        };
    },
};
</script>

<style scoped>
.box-selector {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.box-selector-header {
  padding: 16px;
  border-bottom: 1px solid #dcdfe6;
}

.box-selector-header h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #303133;
}

.box-selector-content {
  flex: 1;
  padding: 8px;
}

.box-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  margin-bottom: 8px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.box-item:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
}

.box-item.active {
  background-color: #ecf5ff;
  border-color: #409eff;
}

.box-info {
  flex: 1;
}

.box-name {
  font-weight: bold;
  margin-bottom: 4px;
  color: #303133;
}

.box-code, .box-type {
  font-size: 12px;
  color: #606266;
  margin-bottom: 2px;
}

.box-status {
  margin-left: 12px;
}

.box-selector-footer {
  padding: 12px 16px;
  border-top: 1px solid #dcdfe6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selected-box-info {
  font-size: 14px;
  color: #606266;
}

.no-data {
  padding: 20px;
  text-align: center;
}
</style>
